import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const Rupeezy: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h2>Rupeezy API Setup in 7 Steps</h2>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 1</h2>
          <p>
            To start click on this link and
            <b> Login Using Rupeezy Credentials</b>
            <br />
            <b>
              <a href="https://vortex.rupeezy.in/create-new-app" target="blank" title="Rupeezy API Login">
                https://vortex.rupeezy.in/create-new-app
              </a>
            </b>
          </p>
        </div>
      </li>

      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 2</h2>
          <p>
            Click
            {oneIndentation}
            <b>Create New App</b>
          </p>
          <img src="/images/broker_setup_guide/rupeezy/rupeezy_app_1.png" alt="Create New App" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 3</h2>
          <p>Fill the below details</p>

          <img src="/images/broker_setup_guide/rupeezy/rupeezy_app_2.1.png" alt="Quantman App details" />

          <div className="stepper__form">
            <div className="stepper__form-group">
              <h6>App Name:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="QUANTMAN" disabled />
                </span>
                <CopyTextButton text="QUANTMAN" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Rupeezy Client ID:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="eg. HIL789" disabled />
                </span>
                <CopyTextButton text="HIL789" disabled />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Redirect URL:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input
                    type="text"
                    placeholder="https://www.quantman.trade/auth/rupeezy/callback"
                    disabled
                  />
                </span>
                <CopyTextButton text="https://www.quantman.trade/auth/rupeezy/callback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Postback URL:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="https://www.quantman.trade/rupeezy/postback" disabled />
                </span>
                <CopyTextButton text="https://www.quantman.trade/rupeezy/postback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Description:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="QUANTMAN" disabled />
                </span>
                <CopyTextButton text="QUANTMAN" />
              </div>
            </div>
          </div>
        </div>
      </li>

      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 4</h2>
          <p>
            Please
            {oneIndentation}
            click on
            {oneIndentation}
            <b>Create</b>
          </p>
        </div>
      </li>

      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 5</h2>
          <p>
            Please
            {oneIndentation}
            click on
            {oneIndentation}
            <b>View Details</b>
          </p>
          <img src="/images/broker_setup_guide/rupeezy/rupeezy_app_3.png" alt="Quantman App details" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 6</h2>
          <img src="/images/broker_setup_guide/rupeezy/rupeezy_app_4.png" alt="Copy and paste api details" />
          <p className="fsize-5 font-weight-bold my-2">
            Now, you can Copy and paste api details in appropriate fields below.
          </p>
        </div>
      </li>
      <li className="stepper_item" data-stepper="7">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click the back button and fill the API credentials in the required field
          </h2>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="Rupeezy fill form" />
        </div>
      </li>
    </div>
  </div>
);

export default Rupeezy;
